/* eslint-disable camelcase */
import { useAuth0 } from '@auth0/auth0-react';

export const useLoginFunctions = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSmsLogin = (returnUrl: string) => {
    loginWithRedirect({
      authorizationParams: { connection: 'sms' },
      appState: { returnTo: returnUrl },
    });
  };

  const handleEmailLogin = (returnUrl: string) => {
    loginWithRedirect({
      authorizationParams: { connection: 'NAFNoActiveDirectoryDb' },
      appState: { returnTo: returnUrl },
    });
  };

  const handleRegister = () => {
    loginWithRedirect({
      authorizationParams: { screen_hint: 'signup' },
    });
  };

  const redirectToHomePage = () => {
    window.location.href = `/`;
  };

  return {
    handleSmsLogin,
    handleEmailLogin,
    handleRegister,
    redirectToHomePage,
  };
};
